export default "__VITE_ASSET__B3WVCmK7__"